import { render, staticRenderFns } from "./overseasCommitteeApplyfor.vue?vue&type=template&id=75239659&scoped=true"
import script from "./overseasCommitteeApplyfor.vue?vue&type=script&lang=js"
export * from "./overseasCommitteeApplyfor.vue?vue&type=script&lang=js"
import style0 from "./overseasCommitteeApplyfor.vue?vue&type=style&index=0&id=75239659&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75239659",
  null
  
)

export default component.exports